import React from "react";

import "./style.scss";

interface Props {
    /** Textual representation of the value as fallback and for SEO */
    textContent: string;
    /*  */
    value: number;
    min?: number;
    max?: number;
    className?: string;
}

export const StarRating = ({ textContent, value, min = 0, max = 5, className }: Props) => {
    const classNames = ["starRating"];
    let percentage = value / ((max - min) / 100);

    // Snap to half Stars
    percentage = Math.round(percentage / 10) * 10;

    if (className) {
        classNames.push("className");
    }

    return (
        <div className={classNames.join(" ")} title={textContent}>
            <span className="filled" style={{ width: `${percentage}%` }}>
                {textContent}
            </span>
        </div>
    );
};
